module.exports = __webpack_public_path__ + "static/media/header_bnk.04264cfc.jpg";